import styled from 'styled-components';

import { flexAsColumn, flexAsRow } from '@components/Styled/mixins';

const DisclaimerContent = styled.span`
  ${flexAsColumn(1)};

  margin-top: ${({ theme }) => theme.spacing(4)};
`;

const NavigatorsSettingsImages = styled.span`
  ${flexAsRow(4)};
`;

const LocationBlockedModalWrapper = styled.div`
  ${flexAsColumn(3)};

  margin: ${({ theme }) => theme.spacing(2)};
  align-items: center;
  text-align: center;

  > div {
    ${flexAsColumn(2)};

    align-items: center;
    text-align: center;

   > p, > strong {
      align-items: center;
      text-align: center;
   }

  > button {
    width: ${({ theme }) => theme.spacing(30)};
  }
`;

export {
  DisclaimerContent,
  LocationBlockedModalWrapper,
  NavigatorsSettingsImages
};
